import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_PL.json';
import exercises from './PILATES_EXERCISES_PL.json';
import recipes from './PILATES_RECIPES_PL.json';

export const PILATES_DATA_PL: ServiceData = {
  articles,
  exercises,
  recipes,
};
